var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fe-text-body-xxs fe-text-primary-grey-60 lg:fe-text-body-s"},[_vm._v(" "+_vm._s(`${_vm.customerName || _vm.createdBy} posted on ${_vm.formattedDate}`)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }